import { withPermissionsModule } from '@/utils/withPermissionsModule';

import { PricingDataForm } from './components/PricingDataForm';
import { PricingSpecDataForm } from './components/PricingSpecDataForm';
import { usePricingCreate } from './hooks/usePricingCreate';

export const PricingCreate = () => {
  const { step, onNext, onPrev, pricingDataForm, requestLoading } = usePricingCreate();

  return (
    <>
      {step === 1 && <PricingDataForm formData={pricingDataForm} onSubmit={onNext} />}
      {step === 2 && <PricingSpecDataForm onSubmit={onNext} onPrev={onPrev} loading={requestLoading} />}
    </>
  );
};

export const PricingCreateModule = withPermissionsModule(PricingCreate);
